import { errorKind } from '../log/clientEventSchema';
import { requestIdOf } from '../log/correlation';

// The step labels are constant UI strings: "Opening SSH tunnel" -> "opening_ssh_tunnel".
const stepCode = label => label.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '').slice(0, 64);

const permIdOf = permId => (/^\d+$/.test(String(permId)) ? Number(permId) : undefined);

// The launch's ids for failures the desktop app reports after the page's flow has moved on.
export const rdpFailureContext = (permId, operation_id) => ({ perm_id: permIdOf(permId), operation_id });

// Fields of connection.launch.failed for an RDP launch: the step that was running, the error's
// code (PORT_IN_USE, ...) or kind, and Tokyo's request id when an API call failed.
export const rdpLaunchFailure = ({ permId, error, steps, isRPi }) => {
  const last = steps[steps.length - 1];
  // ssh2 reports the failing stage as error.level ("client-authentication", "client-timeout").
  const code = error && typeof (error.code || error.level) === 'string' ? (error.code || error.level).toLowerCase() : errorKind(error);
  return {
    connection_type: isRPi ? 'freerdp' : 'rdp',
    step: last ? stepCode(last[0]) : undefined,
    perm_id: permIdOf(permId),
    error_code: code,
    status: error && error.response ? error.response.status : undefined,
    request_id: requestIdOf(error),
  };
};
